import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/index/index'
import Business from '../pages/business/business'
import Solution from '../pages/solution/solution'
import SolutionCase1 from '../pages/solution/solutionCase1'
import SolutionCase2 from '../pages/solution/solutionCase2'
import SolutionCase3 from '../pages/solution/solutionCase3'
import SolutionCase4 from '../pages/solution/solutionCase4'
import SolutionCase5 from '../pages/solution/solutionCase5'
import Case from '../pages/case/case'
import CaseDetail1 from '../pages/case/caseDetail1'
import CaseDetail2 from '../pages/case/caseDetail2'
import CaseDetail3 from '../pages/case/caseDetail3'
import CaseDetail4 from '../pages/case/caseDetail4'
import CaseDetail5 from '../pages/case/caseDetail5'
import News from '../pages/news/news'
import NewsDetail from '../pages/news/newsDetail'
import Jobs from '../pages/jobs/jobs'
import Culture from '../pages/culture/culture'
import About from '../pages/about/about'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/business',
      name: 'Business',
      component: Business
    },
    {
      path: '/solution',
      name: 'Solution',
      component: Solution
    },
    {
      path: '/case',
      name: 'Case',
      component: Case
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/newsDetail',
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/jobs',
      name: 'Jobs',
      component: Jobs
    },
    {
      path: '/culture',
      name: 'Culture',
      component: Culture
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/solutionCase1',
      name: 'SolutionCase1',
      component: SolutionCase1
    },
    {
      path: '/solutionCase2',
      name: 'SolutionCase2',
      component: SolutionCase2
    },
    {
      path: '/solutionCase3',
      name: 'SolutionCase3',
      component: SolutionCase3
    },
    {
      path: '/solutionCase4',
      name: 'SolutionCase4',
      component: SolutionCase4
    },
    {
      path: '/solutionCase5',
      name: 'SolutionCase5',
      component: SolutionCase5
    },
    {
      path: '/caseDetail1',
      name: 'CaseDetail1',
      component: CaseDetail1
    },
    {
      path: '/caseDetail2',
      name: 'CaseDetail2',
      component: CaseDetail2
    },
    {
      path: '/caseDetail3',
      name: 'CaseDetail3',
      component: CaseDetail3
    },
    {
      path: '/caseDetail4',
      name: 'CaseDetail4',
      component: CaseDetail4
    },
    {
      path: '/caseDetail5',
      name: 'CaseDetail5',
      component: CaseDetail5
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js